export const cilHouse = ["24 24","<path d='M17.625 19.057h1.5v-7.432h-5.625v7.432h4.125zM15 13.125h2.625v4.432h-2.625z'></path><path d='M22.016 10.146l-9.309-8.564c-0.283-0.261-0.662-0.421-1.079-0.421-0.44 0-0.839 0.178-1.127 0.467l-9.001 9.001v12.621h5.25v-7.5h3v7.5h12.75v-12.658zM21 21.75h-9.75v-7.5h-6v7.5h-2.25v-10.5l8.561-8.561c0.017-0.017 0.040-0.027 0.066-0.027 0.025 0 0.047 0.009 0.064 0.025l-0-0 9.309 8.564z'></path>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/free/cil-house.js
// module id = null
// module chunks = 